const topbar = {
    docs: 'الوثائق',
    help: 'المساعدة',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
